module.exports = __webpack_public_path__ + "static/media/7.8f4893fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/7.png
// module id = 687
// module chunks = 0